<template>
	<form id="address-form" @submit.prevent="validateForm">
		<div class="modal is-active">
			<div class="modal-background" @click="$emit('close')"></div>
			<div class="modal-card">
				<header class="modal-card-head">
					<h5 v-if="editableAddress.address_id" class="modal-card-title title is-5">
						{{ translations.addresses[editableAddress.address_type_text] }}
					</h5>
				  <h5 v-else class="modal-card-title title is-5">
					{{ translations.addresses[editableAddress.address_type === 'Company invoice address' ? 'invoice' : 'delivery' ] }}
				  </h5>
					<button type="button" class="delete" aria-label="close" @click="$emit('close')"></button>
				</header>
				<section class="modal-card-body">
					<flashes :alerts="alerts.data" v-if="alerts.action === 'modal'"></flashes>
					<div v-if="contact" class="columns">
						<div class="column is-fullwidth">
							<div class="control label-around-input">
								<label class="label" for="company">{{ translations.addresses.company_name }}</label>
								<input class="input" type="text" id="company" v-model="editableAddress.site_name" required minlength="3" name="site_name"/>
							</div>
						</div>
					</div>
					<div class="columns" v-else>
						<div class="column is-fullwidth">
							<div class="control label-around-input">
								<label class="label" for="street">{{ translations.addresses.street }}</label>
								<input class="input" type="text" id="street" v-model="editableAddress.street" required minlength="3" name="street"/>
							</div>
						</div>
					</div>
				  <div v-if="!contact">
					<div class="columns">
					  <div class="column is-one-third">
						<div class="control label-around-input">
						  <template >
							<label class="label" for="number">{{ translations.addresses.number }}</label>
							<input type="text" id="number" class="input" v-model="editableAddress.number" required minlength="1" name="number"/>
						  </template>
						</div>
					  </div>
					  <div class="column is-one-third">
						<div class="control label-around-input">
						  <label class="label" for="box">{{ translations.addresses.box }}</label>
						  <input type="text" id="box" class="input" v-model="editableAddress.box" name="box"/>
						</div>
					  </div>
					</div>
					<div class="columns">
					  <div class="column is-one-third">
						<div class="control label-around-input">
						  <label class="label" for="zip">{{ translations.addresses.zipcode }}</label>
						  <input type="text" id="zip" class="input" v-model="editableAddress.zip_code" required minlength="4" name="postal_code"/>
						</div>
					  </div>
					  <div class="column is-two-thirds">
						<div class="control label-around-input">
						  <label class="label" for="city">{{ translations.addresses.city }}</label>
						  <input type="text" id="city" class="input" v-model="editableAddress.city" required minlength="2" name="city"/>
						</div>
					  </div>
					</div>
					<div class="columns">
					  <div class="column is-fullwidth field" :class="{'is-loading': countries.loading}">
						<div class="control label-around-input">
						  <label class="label" for="country">{{ translations.addresses.country }}</label>
						  <div class="select is-fullwidth">
							<select id="country" v-model="editableAddress.country_id" required name="country_id">
							  <option v-for="country in countries.data" :value="country.country_id">{{ country.name }}</option>
							</select>
						  </div>
						</div>
					  </div>
					</div>
				  </div>
				  <div class="columns" v-else>
						<div class="column is-half">
							<div class="control label-around-input">
								<label class="label" for="contact-firstname">{{ translations.addresses.firstname }}</label>
								<input type="text" id="contact-firstname" class="input" v-model="editableAddress.contact_firstname" minlength="1" name="contact_firstname"/>
							</div>
						</div>
						<div class="column is-half">
							<div class="control label-around-input">
								<label class="label" for="contact-lastname">{{ translations.addresses.lastname }}</label>
								<input type="text" id="contact-lastname" class="input" v-model="editableAddress.contact_lastname" name="contact_lastname"/>
							</div>
						</div>
					</div>
					<div class="columns" v-for="(email, i) in editableAddress.contact_emails">
						<div class="column">
							<div class="control label-around-input has-icons-right">
								<label class="label" :for="'contact-email-'+i">{{ translations.addresses.email }}</label>
								<input class="input" type="email" :id="'contact-email-'+i" v-model="editableAddress.contact_emails[i]" :name="'contact_emails['+i+']'" required minlength="3"/>
								<span v-if="editableAddress.contact_emails.length > 1" class="icon is-right is-clickable" @click="removeEmail(i)">
									<i class="fa-solid fa-xmark"></i>
								</span>
							</div>
							<p v-if="i === (editableAddress.contact_emails.length-1)" class="has-text-right">
								<a href="#" @click.prevent="editableAddress.contact_emails.push('')">
									{{ translations.addresses.add_email }}
								</a>
							</p>
						</div>
					</div>
				</section>
				<footer class="modal-card-foot">
					<div class="container">
						<div class="columns">
							<div class="column is-half">
								<button class="button is-fullwidth" @click.prevent="$emit('close')" type="button">
									{{ translations.modal.cancel }}
								</button>
							</div>
							<div class="column is-half">
								<input type="submit"
									   class="button is-success is-fullwidth track-action"
									   data-ta-event="clientarea-track.company.addresses.address-modal.save"
									   data-ta-action="Click"
									   data-ta-label="Company-page – Addresses – Save address on address modal change"
									   data-ta-page-name="MyCompanyPage"
									   :data-ta-payload="JSON.stringify({'addressId': address.address_id, 'address_type': address.address_type_text})"
									   :value="translations.modal.confirm"
								/>
							</div>
						</div>
					</div>
				</footer>
			</div>
		</div>
	</form>
</template>

<script>
	export default {
		name: "address-modal",
		props: [
			'address',
			'countries',
			'targeturl',
			'translations',
			'alerts',
			'migrated',
			'contact',
			'logEventUrl'
		],
		data ()
		{
			return {
				confirmDelete: false,
				editableAddress: Object.assign(
					{country_id: 1},
					this.address
				),
			}
		},
		computed: {
			isEdition : function () {
			  if(this.contact)
			  {
				return this.address.address_id;
			  }
			  return this.migrated ?  this.editableAddress.id : this.editableAddress.address_id;
			}
		},
		methods: {
			removeEmail(index)
			{
				if( this.editableAddress.contact_emails.length > 1 )
				{
					this.editableAddress.contact_emails.splice(index, 1);
				}
			},
			performDelete: function () {
				(new ApiMonizze())
					.loadData(
						{
							url: this.targeturl + '/' + String(this.address.address_id),
							method: 'delete'
						},
						() => {
							this.confirmDelete = false;
							return this.$emit('deleted');
						}
					)
					.catch(
						() => {
							this.confirmDelete = false;
						}
					);
			},
			validateForm: function () {
				if(!this.contact){
				  (new ApiMonizze())
					  .loadData(
						  {
							url: (this.isEdition) ? this.targeturl + '/' + String(this.address.id): this.targeturl,
							method: (this.isEdition) ? 'patch' : 'post',
							data: this.editableAddress
						  },
						  (data, response) => {
							return this.$emit((this.isEdition) ? 'updated' : 'added', this.$event, response.data);
						  }
					  );
				}
				else
				  {
					(new ApiMonizze())
						.loadData(
							{
							  url: (this.isEdition) ? this.targeturl + '/' + String(this.address.address_id) + '/contact': this.targeturl+ '/contact',
							  method: (this.isEdition) ? 'patch' : 'post',
							  data: this.editableAddress
							},
							(data, response) => {
							  return this.$emit((this.isEdition) ? 'updated' : 'added', this.$event, response.data);
							}
						);
				  }

			}
		}
	}
</script>
